var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinusPurple = function SvgMinusPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 3H3",
    stroke: "url(#minus-purple_svg__a)",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "minus-purple_svg__a",
    x1: -2.577,
    y1: 3.277,
    x2: 29,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1e215b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e215b"
  })))));
};
export default SvgMinusPurple;